import React from "react";
import "./membersMobile.css";
import Profile from "../components/profile";

import Lana from "../profiles/lanab2026.jpeg"
import Helen from "../profiles/helen.jpg";
import Benine from "../profiles/bernie.jpeg"
import Abisai from "../profiles/Abisai Perez-Gomez 2026.jpg"
class members extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
        <div className="parentContainerMembersMobile" style={{height: (this.props.height-50)+'px' , postion:"relative", bottom:'0px'}}>
             <h1 className="pageTitleMobile">Board Members</h1>
             <Profile
          Name={"Lana Burwell"}
          Image={Lana}
          Description={"Secretary"}
          width={"50%"}
          height={"25%"}
        />
            <Profile
          Name={"Helen Canatsey"}
          Description={"Board Member"}
          Image={Helen}
          width={"50%"}
          height={"25%"}
        />
       
        
             <Profile
        Name={"Benine McDonnell"}
          Description={"Board Member"}
          Image={Benine}
          width={"50%"}
          height={"25%"}>
               </Profile>
          <Profile
          Name={"Abisai Perez-Gomez"}
            Description={"Student Board Representative"}
            Image={Abisai}
            width={"50%"}
            height={"25%"}>
          </Profile>
        
      </div>
    );
  }
}
export default members;
